module.exports = __webpack_public_path__ + "static/JetBrainsMono-Bold-d8af470e44be6c1d2d07dee84db355f6.ttf";